
































































import Moment from "moment";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DateDuration } from "../../../../../../domain/system";
import { DocumentInjectedEvidence } from "../../../../../../domain/document";
import { DateDurationPicker, ModelEditableMixin, DropDownSelector } from "../../../../../system";
import { DocumentDurationOptionsSource } from "../../../../selectors/options";

@Component({
  components: {
    DateDurationPicker,
    DropDownSelector,
  }
})
export default class InjectedObjectEvidenceFilter extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: DocumentInjectedEvidence[]) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: DocumentInjectedEvidence[]) => T, defaultValue: T) => T;

  @Prop()
  source: DocumentInjectedEvidence[];

  data(): any {
    return {
      activeNames: [],
      duration: new DateDuration(null, null),
      name: "",
      authorName: "",
      authorRole: "",
      departmentName: "",
      content: "",
    };
  }
  activeNames: string[];
  duration: DateDuration;
  name: string;
  authorName: string;
  authorRole: string;
  departmentName: string;
  content: string;

  mounted(): void {
    this.applyFilter();
  }

  get names(): string[] {
    return this.toOptions(e => e.name);
  }

  get authorNames(): string[] {
    return this.toOptions(e => e.writtenBy ? e.writtenBy.name : null);
  }

  get authorRoles(): string[] {
    return this.toOptions(e => e.writtenBy ? e.writtenBy.role : null);
  }

  get departmentNames(): string[] {
    return this.toOptions(e => e.department);
  }

  toOptions(select: (s: DocumentInjectedEvidence) => string | null): string[] {
    return this.distinct([ "" ].concat(this.source.map(e => select(e)).filter(n => !!n)));
  }

  distinct(source: string[]): string[] {
    return source.filter((v, i, a) => a.indexOf(v) === i);
  }

  get conditionsString(): string {
    const text = [
      this.durationPresentation,
      this.namePresentation,
      this.authorNamePresentation,
      this.authorRolePresentation,
      this.departmentPresentation,
      this.contentPresentation,
    ]
    .filter(t => !!t)
    .join("");
    return "絞り込み：" + (text ? text : "なし");
  }

  get durationPresentation(): string {
    return (!this.duration || (!this.duration.from && !this.duration.to))
      ? ""
      : this.formatCondition("記載日", this.toDurationString(this.duration));
  }

  get namePresentation(): string {
    return !!this.name ? this.formatCondition("名称", this.name) : "";
  }

  get authorNamePresentation(): string {
    return !!this.authorName ? this.formatCondition("記載者", this.authorName) : "";
  }

  get authorRolePresentation(): string {
    return !!this.authorRole ? this.formatCondition("職種", this.authorRole) : "";
  }

  get departmentPresentation(): string {
    return !!this.departmentName ? this.formatCondition("診療科", this.departmentName) : "";
  }

  get contentPresentation(): string {
    return !!this.content ? this.formatCondition("内容", this.content) : "";
  }

  private formatCondition(name: string, value: string): string {
    return value
      ? (name + "【" + value + "】")
      : "";
  }

  private toDurationString(source: DateDuration): string {
    if ((source.from && source.to) || (!source.from && !source.to)) {
      const durationString = DocumentDurationOptionsSource.toDurationString(source);
      return durationString
        ? durationString
        : Moment(source.from).format("YY/MM/DD") + " ～ " + Moment(source.to).format("YY/MM/DD");
    } else if (source.from) {
      return Moment(source.from).format("YY/MM/DD") + " ～";
    } else {
      return  "～ " + Moment(source.to).format("YY/MM/DD");
    }
  }

  clear(): void {
    this.duration = new DateDuration(null, null);
    this.name = "";
    this.authorName = "";
    this.authorRole = "";
    this.departmentName = "";
    this.content = "";
  }

  @Watch("source")
  @Watch("duration")
  @Watch("name")
  @Watch("authorName")
  @Watch("authorRole")
  @Watch("departmentName")
  @Watch("content")
  onFilterChanged(): void {
    this.applyFilter();
  }

  applyFilter(): void {
    this.writePropertyWhenValid(s => s.splice(0, s.length, ...this.source.filter(e => this.isDurationValid(e)
      && this.isNameValid(e)
      && this.isAuthorValid(e)
      && this.isDepartmentValid(e)
      && this.isContentValid(e))));
  }

  isDurationValid(source: DocumentInjectedEvidence): boolean {
    return (!this.duration.from || (!!source.createdAt && Moment(source.createdAt).isSameOrAfter(Moment(this.duration.from), "day")))
        && (!this.duration.to || (!!source.createdAt && Moment(source.createdAt).isSameOrBefore(Moment(this.duration.to), "day")));
  }

  isNameValid(source: DocumentInjectedEvidence): boolean {
    return !this.name
        || (source.name && source.name.indexOf(this.name) >= 0);
  }

  isAuthorValid(source: DocumentInjectedEvidence): boolean {
    return this.isAuthorNameValid(source)
        && this.isAuthorRoleValid(source);
  }

  isAuthorNameValid(source: DocumentInjectedEvidence): boolean {
    return !this.authorName
        || (source.writtenBy && source.writtenBy.name && source.writtenBy.name.indexOf(this.authorName) >= 0);
  }

  isAuthorRoleValid(source: DocumentInjectedEvidence): boolean {
    return !this.authorRole
        || (source.writtenBy && source.writtenBy.role && source.writtenBy.role.indexOf(this.authorRole) >= 0);
  }

  isDepartmentValid(source: DocumentInjectedEvidence): boolean {
    return !this.departmentName
        || (source.department && source.department.indexOf(this.departmentName) >= 0);
  }

  isContentValid(source: DocumentInjectedEvidence): boolean {
    return !this.content
        || (source.type === "text" && source.text && source.text.indexOf(this.content) >= 0);
  }
}
